// Identidade Clusterizze: símbolo (malha de nós com um nó ativo em âmbar) e wordmark.
import type { SVGProps } from 'react';

/** Símbolo: coluna de três nós à esquerda, ligados por barras a dois nós à direita e ao nó ativo (âmbar). */
export function ClusterMark({ size = 28, ...rest }: { size?: number } & SVGProps<SVGSVGElement>) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" {...rest}>
      <g stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" opacity="0.9">
        <path d="M7 6v20" />
        <path d="M7 6h18M7 26h18" />
        <path d="M7 16h11" stroke="var(--fil)" />
      </g>
      <g fill="currentColor">
        <circle cx="7" cy="6" r="3.4" />
        <circle cx="7" cy="16" r="3.4" />
        <circle cx="7" cy="26" r="3.4" />
        <circle cx="25" cy="6" r="3.4" />
        <circle cx="25" cy="26" r="3.4" />
      </g>
      <circle cx="24" cy="16" r="4.4" fill="var(--fil)" />
    </svg>
  );
}

/** Símbolo + "clusterizze" (minúsculo, condensado, pesado) + tagline opcional. */
export function Wordmark({ size = 'md', tagline = false }: { size?: 'sm' | 'md' | 'lg'; tagline?: boolean }) {
  return (
    <span className={`wordmark wm-${size}`}>
      <ClusterMark className="wm-mark" />
      <span className="wm-text">
        <b>clusterizze</b>
        {tagline && <small>malha de inferência</small>}
      </span>
    </span>
  );
}
